import React, { useEffect, useState } from 'react'
import KendoGridPurchaseHistory from '../../components/kendoGrid/kendoGridPurchaseHistory'
import KendoTextFilter from '../../components/kendoGrid/kendoTextFilter'
import KendoTextCellRender from '../../components/kendoGrid/kendoTextCellRender'
import KendoDatePickerFilter from '../../components/kendoGrid/kendoDatePickerFilter'
import ErpRepository from '../../repository/erpRepository'
import { useDispatch } from "react-redux";

const PurchasesHistory = () => {
  const dispatch = useDispatch();
  // TODO: TUG-15166
  const [lista, setLista] = useState([])
  // const response = useSelector(state => state.ordenCompra)
  // const statusPurchase = useSelector(state => state.ordenCompra?.statusPurchaseFilter)
  const [tenantId, setTenantId] = useState(false)
  let columnFields = [
    {
      field: 'plan__commercial_title',
      title: 'Nombre del Plan',
      visibility: true,
      filterCell: KendoTextFilter,
      group: false,
      totField: 0,
      aggregate: true,
    },
    {
      field: 'start_date',
      title: 'Fecha de Pago DD/MM/AA',
      cell: KendoTextCellRender,
      visibility: true,
      filterCell: KendoDatePickerFilter,
      group: false,
    }
  ]

  useEffect(() => {
    fetchDataSubscription()
    // eslint-disable-next-line
  }, [])

  const fetchDataSubscription = async () => {
    try {
      const response = await ErpRepository({
        dispatch,
        datasourceUrl: 'settings/company_setting/',
        method: 'GET',
      })
      const tenantId = response.results[0].tenant_id
      setTenantId(tenantId)
      try {
        const response = await ErpRepository({
          dispatch,
          diferentBaseUrl: true,
          datasourceUrl: `users/company/${tenantId}/payment_subscriptions/`,
          method: 'GET',
        })
        response.results.forEach(item =>
          item['plan__commercial_title'] = item.plan.commercial_title
        )
        setLista(response.results)
      } catch (error) {
        console.log(error)
        throw new Error("Error en la petición a users/company/{tenantId}/payment_subscriptions/")
      }
    } catch (error) {
      console.log(error)
      throw new Error(
        "Error en la petición a 'core/onboarding_steps/status'"
      )
    }
  }

  const fetchDataSubscriptionFilter = async (filters = []) => {
    try {
      let operations = {
        filter: filters,
        skip: 1,
        take: 1,
        all: true
      }
      if (filters === null || filters === undefined) {
        operations = null
      }
      const response = await ErpRepository({
        dispatch,
        diferentBaseUrl: true,
        datasourceUrl: `users/company/${tenantId}/payment_subscriptions/`,
        method: 'GET',
        dataOperations: operations,
      })
      response.results.forEach(item =>
        item['plan__commercial_title'] = item.plan.commercial_title
      )
      setLista(response.results)
    } catch (error) {
      console.log(error)
      throw new Error("Error en la petición a users/company/{tenantId}/payment_subscriptions/")
    }
  }
  const getList = (filters) => {
    fetchDataSubscriptionFilter(filters)
  }
  return (
    <>
      <h2 className="titule-chards">Historial de Compras</h2>
      <div style={{ width: '60%', display: 'block' }} >
        <KendoGridPurchaseHistory
          data={lista} //response.results
          total={15}
          columnsDefinition={columnFields}
          dataOperationAction={dataOperations => {
          }}
          getList={getList}
        />
      </div>
    </>
  )
}

export default PurchasesHistory;